<template>
    <div>
        <Pane title="重新会签评审" :showRemarks="false">
            <template>重新发起项目要求确认及会签评审流程</template>
        </Pane>

        <div class="container">
            <a-skeleton :loading="loading" :paragraph="{ rows: 12 }">
                <a-form :model="form" layout="horizontal" :colon="false" label-align="right"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 12 }">
                    <div class="title" style="margin-top: 0">基本信息</div>
                    <div class="wrapper">
                        <a-row :gutter="16" class="form-panel">
                            <a-col :span="12">
                                <a-form-item label="项目名称" prop="prjName">
                                    <a-input v-model="form.prjName" disabled/>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="项目类型" prop="prjType">
                                    <a-select v-model="form.prjType" placeholder="项目选择后自动带出" disabled>
                                        <a-select-option
                                            v-for="item in projectTypeList"
                                            :key="item.value"
                                            :value="item.value"
                                        >{{ item.name }}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="评审方式" prop="reviewWay">
                                    <a-radio-group v-model="form.reviewWay" placeholder="请选择评审方式" disabled>
                                        <a-radio-button v-for="item in reviewWayList" :key="item.value" :value="item.value">{{ item.name }}</a-radio-button>
                                    </a-radio-group>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="生产部门" prop="prodDeptId" required>
                                    <a-select
                                        show-search
                                        :filter-option="$selectFilterOption"
                                        v-model="form.prodDeptId"
                                        placeholder="项目选择后自动带出"
                                        style="width: 100%"
                                        @focus="fetchProductionOrgList"
                                        @change="handleProdDeptChange"
                                    >
                                        <a-select-option
                                            v-for="item in productionOrgList"
                                            :key="item.id"
                                            :value="item.id"
                                        >{{ item.uniqueName }}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="设计阶段" prop="designPhase" required>
                                    <a-select mode="multiple" v-model="form.designPhase" placeholder="可多选">
                                        <a-select-option v-for="item in designPhaseList" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="项目类别" prop="prjCategory">
                                    <a-radio-group v-model="form.prjCategory" placeholder="请选择项目类别" disabled>
                                        <a-radio-button v-for="item in prjCategoryList" :key="item.value" :value="item.value">{{ item.name }}</a-radio-button>
                                    </a-radio-group>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="投资额(万元)" prop="investment">
                                    <a-input-number v-model="form.investment" style="width: 100%" />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="业主要求开始时间" prop="ownerStartDate" required>
                                    <a-date-picker v-model="form.ownerStartDate" style="width: 100%" />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="业主要求结束时间" prop="ownerEndDate" required>
                                    <a-date-picker v-model="form.ownerEndDate" style="width: 100%" />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="登记人" prop="registerUserName">
                                    <a-input v-model="form.registerUserName" disabled />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </div>
                    <div class="title" style="margin-top: 10px">项目信息</div>
                    <div class="wrapper">
                        <a-row :gutter="16" class="form-panel">
                            <a-col :span="12">
                                <a-form-item label="委托单位">
                                    <CompanySelector @change="onSelectCompany">
                                        <a-button block style="text-align: left; width: 100%;" class="ellipsis">
                                            {{ selectedCompany.custName || selectedCompany.name || form.entrustUnitName || '请选择委托单位' }}
                                        </a-button>
                                    </CompanySelector>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="单位地址" prop="unitAddress">
                                    <a-input v-model="form.unitAddress" />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="国家" prop="country">
                                    <a-select v-model="form.country" placeholder="请选择国家" style="width: 100%">
                                        <a-select-option value="CN">中国</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="所属区域" prop="location">
                                    <a-cascader
                                        placeholder="请选择省市区"
                                        v-model="location"
                                        :options="cityList"
                                        :field-names="{ label: 'name', value: 'id', children: 'children' }"
                                        @change="handleLocationChange"
                                        style="width: 100%"
                                    />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="联系人" prop="contactPerson">
                                    <a-input v-model="form.contactPerson" />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="联系电话" prop="phone">
                                    <a-input v-model="form.phone" />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="项目负责人" prop="prjLeaderId" required>
                                    <EmployeeSelector
                                        @change="handlePrjLeaderChange"
                                        :value="getPrjLeaderValue()"
                                        :single="false"
                                    >
                                        <a-button block style="text-align: left; width: 100%;">{{ form.prjLeaderName || "请选择项目负责人" }}</a-button>
                                    </EmployeeSelector>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="谈判人" prop="negotiatorName">
                                    <EmployeeSelector
                                        @change="(arr) => { handleEmployeeChange(arr, 'negotiator') }"
                                        :value="negotiatorEmployee.name ? [negotiatorEmployee] : []"
                                    >
                                        <a-button block style="text-align: left; width: 100%;">{{ negotiatorEmployee.name || "请选择谈判人" }}</a-button>
                                    </EmployeeSelector>
                                </a-form-item>
                            </a-col>
                            <a-col :lg="12" :md="12" :sm="24">
                                <a-form-item label="专业副总" prop="specVicePresidentId" required>
                                    <a-select
                                        v-model="form.specVicePresidentId"
                                        placeholder="请选择分管副总裁"
                                        show-search
                                        :filter-option="$selectFilterOption"
                                        @change="(value) => handlePersonnelChange(value, 'specVicePresident')"
                                    >
                                        <a-select-option v-for="(item, idx) in personnel.viceChiefEngineers" :key="idx" :value="String(item.userId)">
                                            {{ item.name }}
                                        </a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="管理级别" prop="manageLevel" >
                                    <a-radio-group v-model="form.manageLevel" placeholder="项目选择后自动带出" disabled @change="handleManageLevelChange">
                                        <a-radio-button v-for="item in manageLevelList" :key="item.value" :value="item.value">{{ item.name }}</a-radio-button>
                                    </a-radio-group>
                                </a-form-item>
                            </a-col>
                            <a-col :lg="24" :md="24" :sm="24">
                                <div class="specVicePresident">
                                    <div class="hintName">注：请选择相应专业副总确定项目管理级别。</div>
                                    <div class="hint">
                                        <span class="hintName">吴昊</span>：城市防洪、河道整治、水环境整治工程、给排水、环境卫生工程、规划工程管理；
                                        <span class="hintName">管凛</span>：智慧产业工程；</div>
                                    <div class="hint">
                                        <span class="hintName">韦春陆</span>：道路、桥梁、隧道、管廊、公共交通工程、公路；
                                        <span class="hintName">卢浩</span>：建筑、风景园林、人防、热力、燃气。
                                    </div>
                                </div>
                            </a-col>
                        </a-row>
                        <a-row :gutter="16" class="form-panel">
                            <a-col :span="12">
                                <a-form-item label="部门分管负责人" prop="deptLeaderId">
                                    <a-select disabled
                                        v-model="form.deptLeaderId"
                                        placeholder="请选择部门分管负责人"
                                        show-search
                                        :filter-option="$selectFilterOption"
                                        @change="(value) => handlePersonnelChange(value, 'deptLeader')"
                                    >
                                        <a-select-option v-for="(item, idx) in personnel.masters" :key="idx" :value="String(item.userId)">
                                            {{ item.name }}
                                        </a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="公司分管领导" prop="companyLeaderId">
                                    <a-select
                                        v-model="form.companyLeaderId"
                                        placeholder="请选择公司分管领导"
                                        show-search disabled
                                        :filter-option="$selectFilterOption"
                                        @change="(value) => handlePersonnelChange(value, 'companyLeader')"
                                    >
                                        <a-select-option v-for="(item, idx) in personnel.companyChiefEngineers" :key="idx" :value="String(item.userId)">
                                            {{ item.name }}
                                        </a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label=" " class="hintText">
                                    <div class="hintName">部门分管负责人为部门正职或副职。</div>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label=" " class="hintText">
                                    <div class="hintName">公司管项目需要填写分管领导。</div>
                                </a-form-item>
                            </a-col>
                            <a-col :lg="12" :md="12" :sm="24">
                                <a-form-item label="分管总工" prop="chiefEngineerId">
                                    <a-select
                                        v-model="form.chiefEngineerId"
                                        placeholder="请选择分管总工"
                                        show-search disabled
                                        :filter-option="$selectFilterOption"
                                        @change="(value) => handlePersonnelChange(value, 'chiefEngineer')"
                                    >
                                        <a-select-option v-for="(item, idx) in personnel.deptChiefEngineers" :key="idx" :value="String(item.userId)">
                                            {{ item.name }}
                                        </a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label=" ">

                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label=" ">
                                    <div class="hintName">部门管项目填部门总工或副总工，公司管项目填公司分管总工。</div>
                                </a-form-item>
                            </a-col>
                            <a-col :lg="24" :md="24" :sm="24">
                                <a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }" label="项目要求" prop="requirements" class="full-width-item">
                                    <a-textarea v-model="form.requirements" :rows="3" style="max-width: 100%!important;width: 100%!important;"/>
                                </a-form-item>
                            </a-col>
                            <a-col :lg="24" :md="24" :sm="24">
                                <a-form-item label=" " :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                                    <div class="hintName">包括顾客要求、与建设项目有关的法律法规要求、建设项目的用途（包括预期用途）、公司要求等</div>
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </div>

                    <div class="center">
                        <a-space>
                            <a-button type="primary" @click="submitReview" :loading="submitting">
                                重新提交
                            </a-button>
                            <a-button @click="goBack">返回</a-button>
                        </a-space>
                    </div>
                </a-form>
            </a-skeleton>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { fetchDetail, resubmitPrjReview, getPersonnel } from "@/api/project/review";
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import EmployeeSelector from "@/components/employee-selector";
import CompanySelector from "@/components/company-selector";
import organization from "@/mixins/organization";
import city from "@/mixins/city";
import { fetchList } from "@/api/setting/organization";

export default {
    name: "PrjReviewReapply",
    mixins: [organization, city],
    components: { EmployeeSelector, CompanySelector },
    data() {
        return {
            loading: false,
            submitting: false,
            id: "",
            taskId: "",
            instanceId: "",
            location: [],
            form: {
                prjName: "",
                prjType: "",
                reviewWay: "online",
                manageLevel: "",
                entrustUnitName: "",
                unitAddress: "",
                prodDeptId: "",
                prodDeptName: "",
                designPhase: [],
                investment: undefined,
                ownerStartDate: null,
                ownerEndDate: null,
                registerUserName: "",
                registerUserId: "",
                country: "CN",
                province: "",
                city: "",
                district: "",
                provinceName: "",
                cityName: "",
                districtName: "",
                contactPerson: "",
                phone: "",
                prjLeaderName: "",
                prjLeaderId: "",
                negotiatorName: "",
                negotiatorId: "",
                specVicePresidentName: "",
                specVicePresidentId: "",
                deptLeaderName: "",
                deptLeaderId: "",
                companyLeaderName: "",
                companyLeaderId: "",
                chiefEngineerName: "",
                chiefEngineerId: "",
                requirements: "",
                approveNodes: [],
                prjNo: "",
                registerId: "",
                entrustUnitId: "",
                prjCategory: "",
                remark: "",
                attachment: "",
            },
            negotiatorEmployee: {},
            productionOrgList: [],
            selectedCompany: {},
            personnel: {
                viceChiefEngineers: [],
                deptChiefEngineers: [],
                masters: [],
                companyChiefEngineers: [],
            },
        };
    },
    computed: {
        ...mapState("approval", ["detail"]),
        ...mapGetters("setting", ["findDataDict"]),
        ...mapGetters("auth", ["department"]),
        deptId() {
            return this.department.deptId || '';
        },
        projectTypeList() {
            return this.findDataDict("cosys.projectType");
        },
        manageLevelList() {
            return this.findDataDict("cosys.manageLevel");
        },
        reviewWayList() {
            return this.findDataDict("cosys.reviewWay");
        },
        designPhaseList() {
            return (this.findDataDict && this.findDataDict("cosys.designPhase")) || [];
        },
        prjCategoryList() {
            return this.findDataDict("cosys.prjCategory") || [];
        },
    },
    watch: {
        cityList() {
            this.syncLocation();
        },
    },
    mounted() {
        const { taskId, instanceId } = this.$route.query;
        this.taskId = taskId || "";
        this.instanceId = instanceId || "";

        const routeId = this.$route.params.id;
        if (routeId) {
            this.id = routeId;
        } else {
            const { businessKey } = this.$route.query;
            if (businessKey) {
                const parts = businessKey.split(":");
                this.id = parts.length > 1 ? parts[1] : "";
            }
        }

        if (this.id) {
            this.fetchDetail(this.id);
        }
        this.fetchProductionOrgList();
        if (this.taskId && this.instanceId) {
            this.setTaskId(this.taskId);
            this.setInstanceId(this.instanceId);
        }
    },
    methods: {
        ...mapMutations("approval", ["setTaskId", "setInstanceId"]),
        fetchDetail(id) {
            this.loading = true;
            fetchDetail({ id })
                .then((res) => {
                    const data = res || {};
                    this.form.prjName = data.prjName || "";
                    this.form.prjType = data.prjType || "";
                    this.form.reviewWay = data.reviewWay || "online";
                    this.form.manageLevel = data.manageLevel || "";
                    this.form.entrustUnitName = data.entrustUnitName || "";
                    this.form.unitAddress = data.unitAddress || "";
                    this.form.prodDeptId = data.prodDeptId || "";
                    this.form.prodDeptName = data.prodDeptName || "";
                    this.form.designPhase = typeof data.designPhase === 'string' ? data.designPhase.split(',').filter(Boolean) : (data.designPhase || []);
                    this.form.investment = data.investment;
                    this.form.ownerStartDate = data.ownerStartDate ? moment(data.ownerStartDate) : null;
                    this.form.ownerEndDate = data.ownerEndDate ? moment(data.ownerEndDate) : null;
                    this.form.registerUserName = data.registerUserName || "";
                    this.form.registerUserId = data.registerUserId || "";
                    this.form.country = data.country || "CN";
                    this.form.province = data.province || "";
                    this.form.city = data.city || "";
                    this.form.district = data.district || "";
                    this.form.provinceName = data.provinceName || "";
                    this.form.cityName = data.cityName || "";
                    this.form.districtName = data.districtName || "";
                    this.form.contactPerson = data.contactPerson || "";
                    this.form.phone = data.phone || "";
                    this.form.prjLeaderName = data.prjLeaderName || "";
                    this.form.prjLeaderId = data.prjLeaderId || "";
                    // prjLeader is multi-select, keep comma-separated string
                    this.form.negotiatorName = data.negotiatorName || "";
                    this.form.negotiatorId = data.negotiatorId || "";
                    this.form.specVicePresidentName = data.specVicePresidentName || "";
                    this.form.specVicePresidentId = String(data.specVicePresidentId || "");
                    this.form.deptLeaderName = data.deptLeaderName || "";
                    this.form.deptLeaderId = String(data.deptLeaderId || "");
                    this.form.companyLeaderName = data.companyLeaderName || "";
                    this.form.companyLeaderId = String(data.companyLeaderId || "");
                    this.form.chiefEngineerName = data.chiefEngineerName || "";
                    this.form.chiefEngineerId = String(data.chiefEngineerId || "");
                    this.form.requirements = data.requirements || "";
                    this.form.approveNodes = data.approveNodes || [];
                    this.form.prjNo = data.prjNo || "";
                    this.form.registerId = data.registerId || "";
                    this.form.entrustUnitId = data.entrustUnitId || "";
                    this.form.prjCategory = data.prjCategory || "";
                    this.form.remark = data.remark || "";
                    this.form.attachment = data.attachment || "";

                    // prjLeader now multi-select, displayed via form.prjLeaderName
                    this.negotiatorEmployee = data.negotiatorName
                        ? { name: data.negotiatorName, userId: data.negotiatorId }
                        : {};
                    this.selectedCompany = data.entrustUnitName
                        ? { name: data.entrustUnitName, id: data.entrustUnitId }
                        : {};

                    this.location = [data.province, data.city, data.district].filter(Boolean);

                    // 用回显值预填选项，确保下拉框立即显示名称而非 id
                    const addFallback = (list, id, name) => {
                        if (id && name) list.push({ userId: String(id), name });
                    };
                    this.personnel.viceChiefEngineers = [];
                    this.personnel.deptChiefEngineers = [];
                    this.personnel.masters = [];
                    this.personnel.companyChiefEngineers = [];
                    addFallback(this.personnel.viceChiefEngineers, data.specVicePresidentId, data.specVicePresidentName);
                    addFallback(this.personnel.deptChiefEngineers, data.chiefEngineerId, data.chiefEngineerName);
                    addFallback(this.personnel.masters, data.deptLeaderId, data.deptLeaderName);
                    addFallback(this.personnel.companyChiefEngineers, data.companyLeaderId, data.companyLeaderName);

                    // 再用 getPersonnel 补充完整下拉列表
                    const orgId = data.prodDeptId || this.deptId;
                    if (orgId) {
                        return getPersonnel(orgId).then(res => {
                            // 将 API 返回的 { id, name } 统一为 { userId, name }
                            const normalize = (arr) => (arr || []).filter(item => item.id).map(item => ({
                                userId: String(item.id),
                                name: item.name
                            }));
                            const mergeList = (apiList, id, name) => {
                                const list = normalize(apiList);
                                if (id && name && !list.some(item => String(item.userId) === String(id))) {
                                    return [...list, { userId: String(id), name }];
                                }
                                return list;
                            };
                            this.personnel.viceChiefEngineers = mergeList(res.viceChiefEngineers, this.form.specVicePresidentId, this.form.specVicePresidentName);
                            this.personnel.deptChiefEngineers = mergeList(res.deptChiefEngineers, this.form.chiefEngineerId, this.form.chiefEngineerName);
                            this.personnel.masters = mergeList(res.masters, this.form.deptLeaderId, this.form.deptLeaderName);
                            this.personnel.companyChiefEngineers = mergeList(res.companyChiefEngineers, this.form.companyLeaderId, this.form.companyLeaderName);
                        });
                    }
                })
                .catch(() => {
                    this.$message.error("获取会签评审详情失败");
                    this.loading = false;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        syncLocation() {
            this.location = [];
            if (this.form.province) this.location.push(this.getCityIdByName(this.form.province));
            if (this.form.city) this.location.push(this.getCityIdByName(this.form.city));
            if (this.form.district) this.location.push(this.getCityIdByName(this.form.district));
        },
        getCityNameById(id) {
            if (!id) return '';
            const item = (this.rawCityList || []).find(i => i.id === id);
            return item ? item.name : '';
        },
        getCityIdByName(name) {
            if (!name) return '';
            const item = (this.rawCityList || []).find(i => i.name === name);
            return item ? item.id : '';
        },
        handleLocationChange(val) {
            if (!val) return;
            const provinceCode = val[0] || '';
            const cityCode = val[1] || '';
            const districtCode = val[2] || '';
            const provinceName = this.getCityNameById(provinceCode);
            const cityName = this.getCityNameById(cityCode);
            const districtName = this.getCityNameById(districtCode);
            this.form.province = provinceName;
            this.form.city = cityName;
            this.form.district = districtName;
            this.form.provinceName = provinceName;
            this.form.cityName = cityName;
            this.form.districtName = districtName;
        },
        handleProdDeptChange(value) {
            const selected = this.organizationList.find(item => item.id === value);
            this.form.prodDeptId = value;
            this.form.prodDeptName = selected ? selected.uniqueName : '';
            this.fetchPersonnel(value);
        },
        getPrjLeaderValue() {
            const names = (this.form.prjLeaderName || '').split(',').filter(Boolean);
            const ids = (this.form.prjLeaderId || '').split(',').filter(Boolean);
            return names.map((name, idx) => ({name, userId: ids[idx] || ''}));
        },
        handlePrjLeaderChange(arr) {
            if (arr.length) {
                this.form.prjLeaderName = arr.map(item => item.name).join(',');
                this.form.prjLeaderId = arr.map(item => item.userId).join(',');
            } else {
                this.form.prjLeaderName = '';
                this.form.prjLeaderId = '';
            }
        },
        handleEmployeeChange(arr, type) {
            const mapping = {
                negotiator: { employee: 'negotiatorEmployee', name: 'negotiatorName', id: 'negotiatorId' },
            };
            const map = mapping[type];
            if (arr.length) {
                this[map.employee] = arr[0];
                this.form[map.name] = arr[0].name;
                this.form[map.id] = arr[0].userId;
            } else {
                this[map.employee] = {};
                this.form[map.name] = '';
                this.form[map.id] = '';
            }
        },
        handlePersonnelChange(value, type) {
            const mapping = {
                specVicePresident: { list: 'viceChiefEngineers', name: 'specVicePresidentName' },
                deptLeader: { list: 'masters', name: 'deptLeaderName' },
                companyLeader: { list: 'companyChiefEngineers', name: 'companyLeaderName' },
                chiefEngineer: { list: 'deptChiefEngineers', name: 'chiefEngineerName' },
            };
            const map = mapping[type];
            const person = this.personnel[map.list].find(item => String(item.userId) === String(value));
            this.form[map.name] = person ? person.name : '';

            if (type === 'specVicePresident') {
                this.form.manageLevel = '';
                this.form.deptLeaderName = '';
                this.form.deptLeaderId = '';
                this.form.companyLeaderName = '';
                this.form.companyLeaderId = '';
                this.form.chiefEngineerName = '';
                this.form.chiefEngineerId = '';
            }
        },
        handleManageLevelChange(value) {
            if (value === 'dept') {
                this.form.companyLeaderName = '';
                this.form.companyLeaderId = '';
            }
        },
        onSelectCompany(company) {
            this.selectedCompany = company;
            this.form.entrustUnitName = company.name || company.custName || '';
            this.form.entrustUnitId = company.id || '';
        },
        async fetchPersonnel(orgId) {
            if (!orgId) return;
            try {
                const res = await getPersonnel(orgId);
                const normalize = items => (items || []).map(item => ({
                    ...item,
                    userId: item.userId || item.id
                }));
                this.personnel.viceChiefEngineers = normalize(res.viceChiefEngineers);
                this.personnel.masters = normalize(res.masters);
                this.personnel.companyChiefEngineers = normalize(res.companyChiefEngineers);
                this.personnel.deptChiefEngineers = normalize(res.deptChiefEngineers);
            } catch (e) {
                console.error('获取人员列表失败', e);
            }
        },
        fetchProductionOrgList() {
            if (this.productionOrgList.length) return;
            const searchParams = new URLSearchParams();
            searchParams.append('status', 1);
            searchParams.append('types', 'product');
            searchParams.append('types', 'branch');
            fetchList(searchParams).then(res => {
                this.productionOrgList = res || [];
            }).catch(() => {});
        },
        submitReview() {
            if (!this.form.designPhase || this.form.designPhase.length === 0) {
                this.$message.error('请选择设计阶段'); return;
            }
            if (!this.form.ownerStartDate) {
                this.$message.error('请选择业主要求开始时间'); return;
            }
            if (!this.form.ownerEndDate) {
                this.$message.error('请选择业主要求结束时间'); return;
            }
            if (!this.form.prodDeptId) {
                this.$message.error('请选择生产部门'); return;
            }
            if (!this.form.prjLeaderId) {
                this.$message.error('请选择项目负责人'); return;
            }
            this.submitting = true;
            resubmitPrjReview({
                id: this.id,
                prjName: this.form.prjName,
                prjNo: this.form.prjNo,
                prjType: this.form.prjType,
                manageLevel: this.form.manageLevel,
                registerId: this.form.registerId,
                registerUserName: this.form.registerUserName,
                registerUserId: this.form.registerUserId,
                entrustUnitId: this.form.entrustUnitId,
                entrustUnitName: this.form.entrustUnitName,
                unitAddress: this.form.unitAddress,
                prodDeptId: this.form.prodDeptId,
                prodDeptName: this.form.prodDeptName,
                designPhase: Array.isArray(this.form.designPhase) ? this.form.designPhase.join(',') : this.form.designPhase,
                investment: this.form.investment,
                ownerStartDate: this.form.ownerStartDate ? moment(this.form.ownerStartDate).format('YYYY-MM-DD HH:mm:ss') : '',
                ownerEndDate: this.form.ownerEndDate ? moment(this.form.ownerEndDate).format('YYYY-MM-DD HH:mm:ss') : '',
                country: this.form.country,
                province: this.form.province,
                city: this.form.city,
                district: this.form.district,
                provinceName: this.form.provinceName,
                cityName: this.form.cityName,
                districtName: this.form.districtName,
                contactPerson: this.form.contactPerson,
                phone: this.form.phone,
                prjLeaderName: this.form.prjLeaderName,
                prjLeaderId: this.form.prjLeaderId,
                negotiatorName: this.form.negotiatorName,
                negotiatorId: this.form.negotiatorId,
                specVicePresidentName: this.form.specVicePresidentName,
                specVicePresidentId: this.form.specVicePresidentId,
                deptLeaderName: this.form.deptLeaderName,
                deptLeaderId: this.form.deptLeaderId,
                companyLeaderName: this.form.companyLeaderName,
                companyLeaderId: this.form.companyLeaderId,
                chiefEngineerName: this.form.chiefEngineerName,
                chiefEngineerId: this.form.chiefEngineerId,
                requirements: this.form.requirements,
                prjCategory: this.form.prjCategory,
                remark: this.form.remark,
                attachment: this.form.attachment,
            })
                .then(() => {
                    this.$close(this.$route.path, "/approval/task");
                })
                .catch((e) => {
                    console.error("提交失败详情", e);
                    this.$message.error("提交失败");
                })
                .finally(() => {
                    this.submitting = false;
                });
        },
        goBack() {
            this.$close(this.$route.path);
        },
    },
};
</script>

<style lang="less" scoped>
.container {
    background-color: #fff;
    padding: 24px 160px;
}

.wrapper {
    background-color: #f9f9f9;
    padding-top: 24px;
    padding-bottom: 8px;
}

.title {
    font-weight: bold;
    font-size: 17px;
    margin: 12px 0;
}

.center {
    margin-top: 80px;
    display: flex;
    justify-content: center;
}

.specVicePresident {
    text-align: center;
}

.hint {
    font-size: 12px;
    color: #999;
    line-height: 1.6;
    margin-top: 2px;
    padding-left: 8px;
}

.hintName {
    color: red;
    height: 25px;
    white-space: nowrap;
}

.hintText {
    margin-top: -10px !important;
    height: 25px !important;
}
</style>
